import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "drawer-header" };
const _hoisted_2 = { class: "drawer-content" };
const _hoisted_3 = { class: "form-group" };
const _hoisted_4 = { class: "form-group" };
const _hoisted_5 = { class: "radio-row" };
const _hoisted_6 = { class: "radio-option" };
const _hoisted_7 = { class: "radio-option" };
const _hoisted_8 = { class: "form-group" };
const _hoisted_9 = ["value"];
const _hoisted_10 = { class: "form-group" };
const _hoisted_11 = ["value"];
const _hoisted_12 = {
    key: 0,
    class: "complaint-note"
};
const _hoisted_13 = { class: "form-group" };
const _hoisted_14 = {
    key: 0,
    class: "locked-related"
};
const _hoisted_15 = ["value"];
const _hoisted_16 = { class: "form-group" };
const _hoisted_17 = ["disabled"];
const _hoisted_18 = {
    key: 0,
    class: "collision-warning"
};
const _hoisted_19 = { class: "collision-actions" };
const _hoisted_20 = { class: "form-group" };
const _hoisted_21 = { class: "form-group" };
const _hoisted_22 = { class: "form-group" };
const _hoisted_23 = {
    key: 0,
    class: "form-group"
};
const _hoisted_24 = ["value"];
const _hoisted_25 = {
    key: 1,
    class: "form-error"
};
const _hoisted_26 = ["disabled"];
import { computed, reactive, ref, watch } from 'vue';
import { createCrmContact, createCrmThread, findTitleCollision, EMPTY_GUID } from '@/composables/useAdminCrm';
import { adminState } from '@/composables/useAdminCore';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CrmContactDrawer',
    props: {
        show: { type: Boolean },
        entityType: {},
        entityId: {},
        threads: { default: () => [] },
        methods: { default: () => [] },
        reasons: { default: () => [] },
        operators: { default: () => [] },
        prefill: { default: null }
    },
    emits: ["close", "saved"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const saving = ref(false);
        const error = ref('');
        const form = reactive({
            contactDateTime: '',
            inbound: true,
            contactMethod: '',
            contactReason: '',
            threadId: '',
            title: '',
            body: '',
            notes: '',
            followUpDue: '',
            assignee: 'me',
        });
        const enabledMethods = computed(() => props.methods.filter(m => m.enabled));
        const enabledReasons = computed(() => props.reasons.filter(r => r.enabled));
        const selectedReason = computed(() => props.reasons.find(r => r.id === form.contactReason));
        // Prefilled thread (reply / add-related flows) is fixed, shown as text instead of the select
        const lockedThread = computed(() => !!props.prefill?.thread);
        const lockedThreadTitle = computed(() => props.prefill?.thread?.title || '');
        const collision = computed(() => {
            if (form.threadId || lockedThread.value)
                return null;
            return findTitleCollision(form.title, props.threads);
        });
        function linkToCollision() {
            if (collision.value)
                form.threadId = collision.value.id;
        }
        function nowLocal() {
            const d = new Date();
            d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
            return d.toISOString().slice(0, 16);
        }
        function resetForm() {
            form.contactDateTime = nowLocal();
            form.inbound = props.prefill?.inbound ?? true;
            form.contactMethod = props.prefill?.contactMethod?.id || '';
            form.contactReason = props.prefill?.contactReason?.id || '';
            form.threadId = '';
            form.title = props.prefill?.thread?.title || '';
            form.body = '';
            form.notes = '';
            form.followUpDue = '';
            form.assignee = 'me';
            error.value = '';
        }
        watch(() => props.show, (visible) => {
            if (visible)
                resetForm();
        });
        // Rule 3: choosing an existing thread locks the Title to the thread's title
        watch(() => form.threadId, (id) => {
            if (id)
                form.title = props.threads.find(t => t.id === id)?.title || '';
            else if (!lockedThread.value)
                form.title = '';
        });
        function save() {
            error.value = '';
            if (!form.contactMethod) {
                error.value = 'Please select a contact method';
                return;
            }
            if (!form.contactReason) {
                error.value = 'Please select a reason for contact';
                return;
            }
            if (!form.body.trim()) {
                error.value = 'Please enter the contact body';
                return;
            }
            const existingThread = props.prefill?.thread || props.threads.find(t => t.id === form.threadId) || null;
            if (!existingThread && !form.title.trim()) {
                error.value = 'Please enter a title, or link to an existing contact';
                return;
            }
            if (collision.value) {
                error.value = 'That title already exists — link to it or choose a unique title';
                return;
            }
            saving.value = true;
            if (existingThread) {
                postContact(existingThread);
            }
            else {
                // New subject: create the thread first, then log the contact against it
                createCrmThread(form.title.trim(), (thread) => {
                    postContact(thread);
                }, (message) => {
                    saving.value = false;
                    error.value = message;
                });
            }
        }
        function postContact(thread) {
            // Sub-objects go as id-only stubs — the server attaches existing rows by ID
            const payload = {
                operatorStaffId: adminState.selfId || EMPTY_GUID,
                contactDateTime: new Date(form.contactDateTime).toISOString(),
                inbound: form.inbound,
                contactMethod: { id: form.contactMethod },
                contactReason: { id: form.contactReason },
                thread: { id: thread.id },
                body: form.body.trim(),
                notes: form.notes.trim() || null,
                followUpDue: form.followUpDue ? new Date(form.followUpDue).toISOString() : null,
                followUpOperatorStaffId: form.followUpDue
                    ? (form.assignee === 'me' ? (adminState.selfId || EMPTY_GUID) : form.assignee)
                    : EMPTY_GUID,
            };
            createCrmContact(props.entityType, props.entityId, payload, (created) => {
                saving.value = false;
                // The response echoes the id-only stubs — put the full objects back for the page
                emit('saved', {
                    ...created,
                    thread,
                    contactMethod: props.methods.find(m => m.id === form.contactMethod) || created.contactMethod,
                    contactReason: props.reasons.find(r => r.id === form.contactReason) || created.contactReason,
                });
            }, (message) => {
                saving.value = false;
                error.value = message;
            });
        }
        return (_ctx, _cache) => {
            return (_ctx.show)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "drawer-overlay",
                    onClick: _cache[14] || (_cache[14] = ($event) => (emit('close')))
                }, [
                    _createElementVNode("div", {
                        class: "drawer crm-drawer",
                        onClick: _cache[13] || (_cache[13] = _withModifiers(() => { }, ["stop"]))
                    }, [
                        _createElementVNode("div", _hoisted_1, [
                            _cache[15] || (_cache[15] = _createElementVNode("h3", null, "Log Contact", -1)),
                            _createElementVNode("button", {
                                class: "close-btn",
                                onClick: _cache[0] || (_cache[0] = ($event) => (emit('close')))
                            }, "✕")
                        ]),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _cache[16] || (_cache[16] = _createElementVNode("label", null, "Contact Date/Time:", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.contactDateTime) = $event)),
                                    type: "datetime-local",
                                    class: "form-input"
                                }, null, 512), [
                                    [_vModelText, form.contactDateTime]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                                _cache[19] || (_cache[19] = _createElementVNode("label", null, "Direction:", -1)),
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("label", _hoisted_6, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.inbound) = $event)),
                                            type: "radio",
                                            value: true
                                        }, null, 512), [
                                            [_vModelRadio, form.inbound]
                                        ]),
                                        _cache[17] || (_cache[17] = _createTextVNode(" Inbound "))
                                    ]),
                                    _createElementVNode("label", _hoisted_7, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.inbound) = $event)),
                                            type: "radio",
                                            value: false
                                        }, null, 512), [
                                            [_vModelRadio, form.inbound]
                                        ]),
                                        _cache[18] || (_cache[18] = _createTextVNode(" Outbound "))
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _cache[21] || (_cache[21] = _createElementVNode("label", null, "Method:", -1)),
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((form.contactMethod) = $event)),
                                    class: "form-input"
                                }, [
                                    _cache[20] || (_cache[20] = _createElementVNode("option", {
                                        value: "",
                                        disabled: ""
                                    }, "Select a method…", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(enabledMethods.value, (method) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: method.id,
                                            value: method.id
                                        }, _toDisplayString(method.name), 9, _hoisted_9));
                                    }), 128))
                                ], 512), [
                                    [_vModelSelect, form.contactMethod]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _cache[23] || (_cache[23] = _createElementVNode("label", null, "Reason:", -1)),
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((form.contactReason) = $event)),
                                    class: "form-input"
                                }, [
                                    _cache[22] || (_cache[22] = _createElementVNode("option", {
                                        value: "",
                                        disabled: ""
                                    }, "Select a reason…", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(enabledReasons.value, (reason) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: reason.id,
                                            value: reason.id
                                        }, _toDisplayString(reason.name), 9, _hoisted_11));
                                    }), 128))
                                ], 512), [
                                    [_vModelSelect, form.contactReason]
                                ]),
                                (selectedReason.value && selectedReason.value.complaint)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, " This will be recorded as a complaint. "))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                _cache[25] || (_cache[25] = _createElementVNode("label", null, "Related to:", -1)),
                                (lockedThread.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(lockedThreadTitle.value), 1))
                                    : _withDirectives((_openBlock(), _createElementBlock("select", {
                                        key: 1,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((form.threadId) = $event)),
                                        class: "form-input"
                                    }, [
                                        _cache[24] || (_cache[24] = _createElementVNode("option", { value: "" }, "None — new subject", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.threads, (t) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: t.id,
                                                value: t.id
                                            }, _toDisplayString(t.title), 9, _hoisted_15));
                                        }), 128))
                                    ], 512)), [
                                        [_vModelSelect, form.threadId]
                                    ])
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                                _cache[26] || (_cache[26] = _createElementVNode("label", null, "Title:", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((form.title) = $event)),
                                    type: "text",
                                    class: "form-input",
                                    placeholder: "A few words describing the contact…",
                                    disabled: !!form.threadId || lockedThread.value
                                }, null, 8, _hoisted_17), [
                                    [_vModelText, form.title]
                                ]),
                                (collision.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        _createElementVNode("div", null, "A contact titled “" + _toDisplayString(collision.value.title) + "” already exists.", 1),
                                        _createElementVNode("div", _hoisted_19, [
                                            _createElementVNode("button", {
                                                class: "action-btn secondary",
                                                onClick: linkToCollision
                                            }, "Link to existing"),
                                            _createElementVNode("button", {
                                                class: "action-btn secondary",
                                                onClick: _cache[8] || (_cache[8] = ($event) => (form.title = ''))
                                            }, "Use a different title")
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                                _cache[27] || (_cache[27] = _createElementVNode("label", null, "Body:", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((form.body) = $event)),
                                    class: "form-textarea",
                                    rows: "5",
                                    placeholder: "The body of the email, or a log of the call…"
                                }, null, 512), [
                                    [_vModelText, form.body]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                                _cache[28] || (_cache[28] = _createElementVNode("label", null, "Notes (optional):", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((form.notes) = $event)),
                                    class: "form-textarea",
                                    rows: "3",
                                    placeholder: "Additional notes…"
                                }, null, 512), [
                                    [_vModelText, form.notes]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                                _cache[29] || (_cache[29] = _createElementVNode("label", null, "Follow-up due (optional):", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((form.followUpDue) = $event)),
                                    type: "date",
                                    class: "form-input"
                                }, null, 512), [
                                    [_vModelText, form.followUpDue]
                                ])
                            ]),
                            (form.followUpDue)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    _cache[31] || (_cache[31] = _createElementVNode("label", null, "Assign follow-up to:", -1)),
                                    _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((form.assignee) = $event)),
                                        class: "form-input"
                                    }, [
                                        _cache[30] || (_cache[30] = _createElementVNode("option", { value: "me" }, "Me", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operators, (op) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                                key: op.id,
                                                value: op.id
                                            }, _toDisplayString(op.name), 9, _hoisted_24));
                                        }), 128))
                                    ], 512), [
                                        [_vModelSelect, form.assignee]
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (error.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(error.value), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("button", {
                                class: "action-btn primary save-btn",
                                disabled: saving.value,
                                onClick: save
                            }, _toDisplayString(saving.value ? 'Logging…' : 'Log Contact'), 9, _hoisted_26)
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
